<template>
	<div id="vx-col w-full mb-base">
		<!-- PRODUCT TABLE -->
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression de la prestation ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<div>
			<FilterCard
				:refreshKey="filterRefreshKey"
				:filters="filtersTemplates"
				:showListLength="displayedProducts.length"
				@filter="handleFilterEmits($event)"
				:actions="actionsTemplates"
				@action="handleActionEmits($event)"
				:onChangeEmit="true"
			/>
		</div>

		<vx-card
			class="mt-1"
			v-if="allProducts"
			style="max-height: 69vh; overflow: auto"
		>
			<vs-table max-items="10" stripe :data="displayedProducts">
				<template slot="thead">
					<vs-th class="th-sticky">Catégorie</vs-th>
					<vs-th class="th-sticky">Sous-catégorie</vs-th>
					<vs-th class="th-sticky">Prestation</vs-th>
					<vs-th class="th-sticky">Description courte</vs-th>
					<vs-th class="th-sticky">Description longue</vs-th>
					<vs-th class="th-sticky">Devise</vs-th>
					<vs-th class="th-sticky">Langue</vs-th>
					<vs-th class="th-sticky">Prestation?</vs-th>
					<vs-th class="th-sticky">Commande?</vs-th>
					<vs-th class="th-sticky">Flexible?</vs-th>
					<!-- <vs-th>Type de prestation</vs-th> -->
					<vs-th class="th-sticky" v-if="$acl.check('admin')"></vs-th>
					<vs-th class="th-sticky" v-if="$acl.check('sadmin')"></vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="index" v-for="(tr, index) in data">
						<div v-show="false">
							{{ setRowNum(data.length) }}
						</div>

						<vs-td>{{ tr.category_name }}</vs-td>
						<vs-td>{{ tr.sub_category_name }}</vs-td>
						<vs-td>{{ tr.perform }}</vs-td>
						<vs-td>{{ tr.short_description }}</vs-td>
						<vs-td class="w-1/2">{{ tr.long_description }}</vs-td>
						<vs-td>{{ tr.currency }}</vs-td>
						<vs-td>{{ tr.language_name }}</vs-td>
						<vs-td>{{ tr.missionable == 1 ? "Oui" : "Non" }}</vs-td>
						<vs-td>{{ tr.deliverable == 1 ? "Oui" : "Non" }}</vs-td>
						<vs-td>{{ tr.flexible == 1 ? "Oui" : "Non" }}</vs-td>
						<!-- <vs-td>{{ getNetlinkName(tr.is_netlink) }}</vs-td> -->
						<vs-td v-if="$acl.check('admin')">
							<vx-tooltip text="Modifier" position="top">
								<vs-button
									size="large"
									color="primary"
									type="flat"
									icon-pack="feather"
									icon="icon-edit-2"
									@click="
										$router.push({
											name: 'update_entity',
											params: {
												productId: tr.id,
												updateEntityForm: 'products',
											},
										})
									"
								></vs-button>
							</vx-tooltip>
						</vs-td>
						<vs-td v-if="$acl.check('sadmin')">
							<vx-tooltip text="Effacer" position="top">
								<vs-button
									size="large"
									color="danger"
									type="flat"
									icon-pack="feather"
									icon="icon-trash-2"
									@click="displayValidationPopup(tr)"
								></vs-button>
							</vx-tooltip>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import FilterCard from "@/views/filters/FilterCard";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import Product from "@/entities/Product";
import Society from "@/entities/Society";
import XLSX from "xlsx";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";

export default {
	components: { FilterCard, VxCard },
	name: "ProductsDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			selectedContract: null,
			showContractPopup: false,
			currencies: [],
			categoryFilter: "",
			categoryFilterOn: false,
			languageFilter: "",
			languageFilterOn: false,
			subCategoryFilter: "",
			subCategoryFilterOn: false,
			currencyFilter: "",
			currencyFilterOn: false,
			productFilter: "",
			productFilterOn: false,
			displayedProducts: [],
			displayedProductsFull: [],
			showValidationPopup: false,
			productToDelete: null,
			filterRefreshKey: 0,
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "new_product",
					buttonName: "Nouvelle prestation",
					buttonIcon: "icon-plus-circle",
					buttonColor: "primary",
				},
				{
					order: 2,
					emitSlugName: "action_extract_products",
					buttonName: "Exporter",
					buttonIcon: "icon-download-cloud",
					buttonColor: "dark",
				},
			],
			filtersTemplates: [
				{
					order: 3,
					emitSlugName: "filter_product",
					filterPlaceHolder: "Prestation",
					value: "",
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_category",
					filterPlaceHolder: "Catégorie",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 1,
					emitSlugName: "filter_subCategory",
					filterPlaceHolder: "Sous-catégorie",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 14,
					emitSlugName: "filter_currency",
					filterPlaceHolder: "Devise",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 15,
					emitSlugName: "filter_language",
					filterPlaceHolder: "Langue",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
			],
		};
	},
	async created() {
		await this.getAllProducts();
		await this.$store.dispatch("getAllProductsCategories");
		await this.$store.dispatch("getAllProductsSubCategories");
		await this.getAllProductsCategories();
		await this.getAllProductsSubCategories();
		await this.getCurrencies();
		await this.getLanguages();
	},
	mounted() {
		this.displayedProducts = this.allProducts;
		this.displayedProductsFull = this.allProducts;
	},
	watch: {
		allProductsCategories: function () {
			this.getAllProductsCategories();
		},
		allProductsSubCategories: function () {
			this.getAllProductsSubCategories();
		},
		allProducts: function () {
			this.displayedProductsFull = this.allProducts;
			this.displayedProducts = this.allProducts;
		},
		categoryFilter: function () {
			if (this.categoryFilter == "") {
				this.categoryFilterOn = false;
			} else {
				this.categoryFilterOn = true;
			}
			////console.log("categoryFilter")
			this.displayedProducts = this.filterProducts(this.displayedProductsFull);
		},
		currencyFilter: function () {
			if (this.currencyFilter == "") {
				this.currencyFilterOn = false;
			} else {
				this.currencyFilterOn = true;
			}
			////console.log("currencyFilter")
			this.displayedProducts = this.filterProducts(this.displayedProductsFull);
		},
		languageFilter: function () {
			if (this.languageFilter == "") {
				this.languageFilterOn = false;
			} else {
				this.languageFilterOn = true;
			}
			////console.log("languageFilter")
			this.displayedProducts = this.filterProducts(this.displayedProductsFull);
		},
		subCategoryFilter: function () {
			if (this.subCategoryFilter == "") {
				this.subCategoryFilterOn = false;
			} else {
				this.subCategoryFilterOn = true;
			}
			////console.log("subCategoryFilter")
			this.displayedProducts = this.filterProducts(this.displayedProductsFull);
		},
		productFilter: function () {
			if (this.productFilter == "") {
				this.productFilterOn = false;
			} else {
				this.productFilterOn = true;
			}
			////console.log("categoryFilter")
			this.displayedProducts = this.filterProducts(this.displayedProductsFull);
		},
		displayedProducts: function (data) {
			if (data.length == 0) {
				this.setRowNum(0);
			}
		},
	},
	computed: {
		allProducts: () => {
			return store.state.products;
		},
		allProductsCategories: () => {
			return store.state.products_categories;
		},
		allProductsSubCategories: () => {
			return store.state.products_sub_categories;
		},
	},

	methods: {
		async getCurrencies() {
			let req = await Product.getCurrencies();
			this.currencies = req;
			//Changing sub_name in to id to use it as default value in dropdown
			this.currencies.forEach((obj) => {
				if (obj.hasOwnProperty("sub_name")) {
					obj["id"] = obj["sub_name"];
					delete obj["sub_name"];
				}
			});
			this.filtersTemplates[3].params.dropdownValues = this.currencies;
			this.filterRefreshKey++;
		},
		async getLanguages() {
			let req = await Society.getLanguages();
			this.languages = req;
			this.filtersTemplates[4].params.dropdownValues = this.languages;
			this.filterRefreshKey++;
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},

		async getAllProducts() {
			await this.$store.dispatch("getAllProducts");
		},
		async getAllProductsCategories() {
			// await this.$store.dispatch("getAllProductsCategories");
			this.filtersTemplates[1].params.dropdownValues =
				this.allProductsCategories;
			this.filterRefreshKey++;
		},
		async getAllProductsSubCategories() {
			// await this.$store.dispatch("getAllProductsSubCategories");
			this.filtersTemplates[2].params.dropdownValues =
				this.allProductsSubCategories;
			this.filterRefreshKey++;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_product":
					this.productFilter = receivedEmit[1].value;
					break;
				case "filter_category":
					this.categoryFilter = receivedEmit[1].value;
					break;
				case "filter_subCategory":
					this.subCategoryFilter = receivedEmit[1].value;
					break;
				case "filter_currency":
					this.currencyFilter = receivedEmit[1].value;
					break;
				case "filter_language":
					this.languageFilter = receivedEmit[1].value;
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "action_extract_products":
					this.exportData(this.allProducts);
					break;
				case "new_product":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.$router.push({ name: "new_entity" });
					break;
				default:
					break;
			}
		},
		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (this.categoryFilterOn || this.subCategoryFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered products
		 * @param {String} categoryFilter - Type of delivery
		 * @param {String} productFilter - String to match in product name
		 * @return {List} - Products' list filtered
		 */
		filterProducts(products) {
			////console.log("filterProviders BEGIN")
			let productList = [];
			let searchKeyList = {};

			if (this.subCategoryFilterOn) {
				searchKeyList["subCategoryFilter"] = this.subCategoryFilter;
			}

			if (this.categoryFilterOn) {
				searchKeyList["categoryFilter"] = this.categoryFilter;
			}

			if (this.productFilterOn) {
				searchKeyList["productFilter"] = this.productFilter.toLowerCase();
			}
			if (this.currencyFilterOn) {
				searchKeyList["currencyFilter"] = this.currencyFilter;
			}
			if (this.languageFilterOn) {
				searchKeyList["languageFilter"] = this.languageFilter;
			}

			//console.log("searchKeyList", searchKeyList);
			for (let productToFilter of products) {
				let contractSearchKeyList = {};
				this.categoryFilterOn
					? (contractSearchKeyList["categoryFilter"] = productToFilter.category)
					: false;
				this.subCategoryFilterOn
					? (contractSearchKeyList["subCategoryFilter"] =
							productToFilter.sub_category)
					: false;
				this.productFilterOn
					? (contractSearchKeyList["productFilter"] =
							productToFilter.perform.toLowerCase())
					: false;
				this.currencyFilterOn
					? (contractSearchKeyList["currencyFilter"] =
							productToFilter.currency.toLowerCase())
					: false;
				console.log("productToFilter", productToFilter);
				this.languageFilterOn
					? (contractSearchKeyList["languageFilter"] =
							productToFilter.language_id)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof contractSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof contractSearchKeyList[key] == "string") {
							if (
								!contractSearchKeyList[key].includes(
									searchKeyList[key].toLowerCase()
								)
							) {
								check = false;
								break;
							}
						} else if (typeof contractSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of contractSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else {
						if (contractSearchKeyList[key] != searchKeyList[key]) {
							check = false;
							break;
						}
					}
				}

				if (check) productList.push(productToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return productList;
		},

		deleteProduct(product) {
			//console.log(product);
			let productToDelete = new Product(product);
			//console.log(productToDelete);
			productToDelete.delete((err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						//console.log(res);
						this.displayedProductsFull = this.displayedProductsFull.filter(
							function (element) {
								return element.id != product.id;
							}
						);
						this.displayedProducts = this.displayedProductsFull;
					}
			});
		},

		displayValidationPopup(product) {
			this.productToDelete = product;
			this.showValidationPopup = true;
		},

		accept() {
			this.deleteProduct(this.productToDelete);
			this.showValidationPopup = false;
		},

		decline() {
			this.productToDelete = null;
			this.showValidationPopup = false;
		},
		exportData(dataIn) {
			let data = JSON.parse(JSON.stringify(dataIn));

			for (let i = 0; i < data.length; i++) {
				this.$delete(data[i], "is_netlink");
				this.$delete(data[i], "sub_category");
				this.$delete(data[i], "meeting_count");
				this.$delete(data[i], "category");
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "";

			let header = {
				header: [
					"id",
					"qb_id",
					"category_name",
					"sub_category_name",
					"perform",
					"short_description",
					"long_description",
					"currency",
					"missionable",
					"deliverable",
					"flexible",
				],
				skipHeader: true,
				origin: -1,
			};

			let header_names = [
				{
					id: "Identifiant",
					qb_id: "QB Id",
					category_name: "Catégorie",
					sub_category_name: "Sous-Catégorie",
					perform: "Prestation",
					short_description: "Description courte",
					long_description: "Description longue",
					currency: "Devise",
					missionable: "Missionable",
					deliverable: "Deliverable",
					flexible: "Flexible",
				},
			];

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Produits_export.xls");
		},
	},
};
</script>

<style lang="scss">
.fw-bold {
	font-weight: bold;
	color: black;
}

.center {
	justify-content: center;
}

.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>
